import type { FC } from "react";
import { useEffect, useRef, useState } from "react";

import { random } from "lodash";

export declare type InlineFrameParams = {
    bundle: string;
    id?: string;
    zorder?: number;
};
export const BundleFrame: FC<InlineFrameParams> = ({ bundle, id = `${random(1, 1000)}`, zorder = 1040 }) => {
    const divRef = useRef<HTMLDivElement>(null);
    const [nameId, setNameId] = useState<string>(`__${bundle}_${id}_sizer__`);
    useEffect(() => setNameId(`__${bundle}_${id}_sizer__`), [bundle, id]);
    useEffect(() => {
        window.SwHook?.createFrame(bundle, id, zorder, nameId, null, null, { app: "Pro" });
        return () => {
            window.SwHook.destroyFrame(bundle, id);
        };
    }, []);
    return (
        <div
            id={nameId}
            ref={divRef}
            style={{ width: "100%", height: "100%" }}
        />
    );
};
